// RTB-кампании: ручные (выбор экранов) и пакетные (пакет экранов). Список общий, формы раздельные.
export const RTB_CAMPAIGN_NAME_PATTERN = /^[A-Za-zА-Яа-яЁё0-9 ]+$/;
export const RTB_CAMPAIGN_NAME_DISALLOWED = /[^A-Za-zА-Яа-яЁё0-9 ]/g;
export const RTB_CAMPAIGN_NAME_CHARSET_MESSAGE = 'Название может содержать только русские и английские буквы, цифры и пробелы';

export const RTB_CAMPAIGN_TYPE = Object.freeze({
    MANUAL: 'manual',
    PACKAGE: 'package',
    POI: 'poi',
});

export const RTB_CAMPAIGN_LIST_ENDPOINT = Object.freeze({
    [RTB_CAMPAIGN_TYPE.MANUAL]: '/rtb/campaigns/data',
    [RTB_CAMPAIGN_TYPE.PACKAGE]: '/rtb/package-campaigns/data',
    [RTB_CAMPAIGN_TYPE.POI]: '/rtb/poi-campaigns/data',
});

export const RTB_CAMPAIGN_SAVE_ENDPOINT = Object.freeze({
    [RTB_CAMPAIGN_TYPE.MANUAL]: '/rtb/campaigns',
    [RTB_CAMPAIGN_TYPE.PACKAGE]: '/rtb/package-campaigns',
    [RTB_CAMPAIGN_TYPE.POI]: '/rtb/poi-campaigns',
});

export const RTB_CAMPAIGN_INDEX_PATH = Object.freeze({
    [RTB_CAMPAIGN_TYPE.MANUAL]: '/rtb/campaigns',
    [RTB_CAMPAIGN_TYPE.PACKAGE]: '/rtb/package-campaigns',
    [RTB_CAMPAIGN_TYPE.POI]: '/rtb/poi-campaigns',
});

export const RTB_CAMPAIGN_EXPORT_PATH = Object.freeze({
    [RTB_CAMPAIGN_TYPE.MANUAL]: id => `/rtb/campaigns/${id}/export`,
    [RTB_CAMPAIGN_TYPE.PACKAGE]: id => `/rtb/package-campaigns/${id}/export`,
    [RTB_CAMPAIGN_TYPE.POI]: id => `/rtb/poi-campaigns/${id}/export`,
});

// Зеркало CampaignRtb::displayStatuses(); подписи приходят с бэкенда, дублируем для форм и модерации.
export const RTB_DISPLAY_STATUS = Object.freeze({
    DRAFT: 'draft',
    PAUSED: 'paused',
    PENDING: 'pending',
    ACTIVE: 'active',
    REJECTED: 'rejected',
    EXHAUSTED: 'exhausted',
    COMPLETED: 'completed',
});

export const RTB_STATUS_LABEL = Object.freeze({
    [RTB_DISPLAY_STATUS.DRAFT]: 'Черновик',
    [RTB_DISPLAY_STATUS.PAUSED]: 'На паузе',
    [RTB_DISPLAY_STATUS.PENDING]: 'На модерации',
    [RTB_DISPLAY_STATUS.ACTIVE]: 'Активна',
    [RTB_DISPLAY_STATUS.REJECTED]: 'Отклонена',
    [RTB_DISPLAY_STATUS.EXHAUSTED]: 'Лимит исчерпан',
    [RTB_DISPLAY_STATUS.COMPLETED]: 'Завершена',
});

export const RTB_STATUS_TONE = Object.freeze({
    [RTB_DISPLAY_STATUS.DRAFT]: 'neutral',
    [RTB_DISPLAY_STATUS.PAUSED]: 'muted',
    [RTB_DISPLAY_STATUS.PENDING]: 'warning',
    [RTB_DISPLAY_STATUS.ACTIVE]: 'success',
    [RTB_DISPLAY_STATUS.REJECTED]: 'danger',
    [RTB_DISPLAY_STATUS.EXHAUSTED]: 'warning',
    [RTB_DISPLAY_STATUS.COMPLETED]: 'muted',
});

export const RTB_STATUS_HINT = Object.freeze({
    [RTB_DISPLAY_STATUS.DRAFT]: 'Не участвует в показах. Заполните кампанию и сохраните её без черновика.',
    [RTB_DISPLAY_STATUS.PAUSED]: 'Показы остановлены вручную. Запустите кампанию, чтобы продолжить.',
    [RTB_DISPLAY_STATUS.PENDING]: 'Ждёт проверки модератором. Показы начнутся после одобрения.',
    [RTB_DISPLAY_STATUS.ACTIVE]: 'Кампания участвует в показах.',
    [RTB_DISPLAY_STATUS.REJECTED]: 'Отклонена модератором. Исправьте кампанию и сохраните — она снова уйдёт на модерацию.',
    [RTB_DISPLAY_STATUS.EXHAUSTED]: 'Достигнут лимит бюджета или показов. Показы возобновятся с новыми сутками или после увеличения лимита.',
    [RTB_DISPLAY_STATUS.COMPLETED]: 'Период кампании закончился. Продлите даты, чтобы возобновить показы.',
});

export const RTB_USER_STATUS_OPTIONS = Object.freeze([
    { value: RTB_DISPLAY_STATUS.ACTIVE, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.ACTIVE] },
    { value: RTB_DISPLAY_STATUS.PAUSED, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.PAUSED] },
]);

export const RTB_SYSTEM_STATUS_OPTIONS = Object.freeze([
    { value: RTB_DISPLAY_STATUS.PENDING, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.PENDING] },
    { value: RTB_DISPLAY_STATUS.ACTIVE, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.ACTIVE] },
    { value: RTB_DISPLAY_STATUS.REJECTED, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.REJECTED] },
    { value: RTB_DISPLAY_STATUS.EXHAUSTED, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.EXHAUSTED] },
    { value: RTB_DISPLAY_STATUS.COMPLETED, label: RTB_STATUS_LABEL[RTB_DISPLAY_STATUS.COMPLETED] },
]);

// Зеркало CampaignRtbModerationRules::MATERIAL_FIELDS.
export const RTB_MATERIAL_FIELDS = Object.freeze([
    'start_date',
    'end_date',
    'budget_total_limit',
    'budget_daily_limit',
    'impr_total_limit',
    'impr_daily_limit',
    'creative_ids',
    'frame_gids',
    'screen_package_id',
]);

// Зеркало CampaignRtbListRequest::SORTS и PER_PAGE.
export const RTB_LIST_SORT_OPTIONS = Object.freeze([
    { value: 'created_at:desc', label: 'Сначала новые' },
    { value: 'created_at:asc', label: 'Сначала старые' },
    { value: 'name:asc', label: 'По названию, А–Я' },
    { value: 'name:desc', label: 'По названию, Я–А' },
    { value: 'start_date:desc', label: 'По дате начала' },
    { value: 'end_date:asc', label: 'По дате окончания' },
]);

export const RTB_LIST_PER_PAGE_OPTIONS = Object.freeze([10, 25, 50, 100]);

export const RTB_LIST_DEFAULTS = Object.freeze({
    search: '',
    status: RTB_DISPLAY_STATUS.ACTIVE,
    advertiserId: '',
    sort: 'created_at:desc',
    page: 1,
    perPage: 25,
});

export const RTB_ROW_ACTION = Object.freeze({
    EDIT: 'edit',
    TOGGLE: 'toggle',
    STATISTICS: 'statistics',
    EXPORT_SCREENS: 'export_screens',
    DELETE: 'delete',
});
